import React, { useState, useEffect } from 'react'
import FormField from '../../Components/common-components/form-input';
import useAccounts from './Hooks/useAccounts';
import { Spinner } from '../../Components/common-components/spinner';
// import PaginationCom from '../../Components/Pagination';
import moment from 'moment-timezone';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { toast, ToastContainer } from 'react-toastify';
import { NavLink, useNavigate } from 'react-router-dom';
import { FormControl, Radio, RadioGroup, Select, Tooltip, FormLabel } from '@mui/material';

import DateInput from "../../Components/common-components/DateInput"
// import ListingSkeleton from '../../Components/suspenceUi/ListingSkeleton';
import { IoAddCircle, IoRemoveCircle } from 'react-icons/io5'
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';



const type_of_service = [
    { name: 'MEDICAL CARE', key: 'MEDICALCARE' },
    { name: 'SURGERY', key: 'SURGERY' },
    { name: 'CONSULTATION', key: 'CONSULTATION' },
    { name: 'DIAGNOSTIC X-RAY', key: 'DIAGNOSTICXRAY' },
    { name: 'DIAGNOSTIC LABORATORY', key: 'DIAGNOSTICLABORATORY' },
    { name: 'RADIATION THERAPY', key: 'RADIATIONTHERAPY' },
    { name: 'ANESTHESIA', key: 'ANESTHESIA' },
    { name: 'SURGICAL ASSISTANCE', key: 'SURGICALASSISTANCE' },
    { name: 'OTHER MEDICAL', key: 'OTHERMEDICAL' },
    { name: 'BLOOD CHARGES', key: 'BLOODCHARGES' },
    { name: 'USED DME', key: 'USEDDME' },
    { name: 'DME PURCHASE', key: 'DMEPURCHASE' },
    { name: 'ASC FACILITY', key: 'ASCFACILITY' },
    { name: 'RENAL SUPPLIES IN THE HOME', key: 'RENALSUPPLIESINTHEHOME' },
    { name: 'ALTERNATE METHOD DIALYSIS', key: 'ALTERNATEMETHODDIALYSIS' },
    { name: 'CRD EQUIPMENT', key: 'CRDEQUIPMENT' },
    { name: 'PRE-ADMISSION TESTING', key: 'PREADMISSIONTESTING' },
    { name: 'DME RENTAL', key: 'DMERENTAL' },
    { name: 'PNEUMONIA VACCINE', key: 'PNEUMONIAVACCINE' },
    { name: 'SECOND SURGICAL OPINION', key: 'SECONDSURGICALOPINION' },
    { name: 'THIRD SURGICAL OPINION', key: 'THIRDSURGICALOPINION' },
]
const UpdateSuperBill = () => {
    const { methods, data } = useAccounts()
    const {
        handleRadioChange,
        handleInputChange,
        setNewdata,
        handleUpdateBill,
        setResponsibleParty,
        setAcceptAssignment

    } = methods
    const {
        spinner,
        palceOfTreatmentlist,
        claimFormError,
        selectedItems,
        icdCodes,
        newdata,
        providerList,
        responsibleParty,
        acceptAssignment

    } = data
    const [anchorEl, setAnchorEl] = useState(null);

    const [anchorElPhase, setAnchorElPhase] = useState(null);
    const [anchorElOrder, setAnchorElOrder] = useState(null);
    const [canAddMore, setCanAddMore] = useState(false);
    const open = Boolean(anchorEl);
    const openPhase = Boolean(anchorElPhase);
    const openOrder = Boolean(anchorElOrder);
    const ITEM_HEIGHT = 48;
    const navigate = useNavigate()


    const handleChange = (event) => {
        const { name, value } = event.target
        let updatedValue = value;
        setNewdata((prev) => ({
            ...prev,
            [name]: updatedValue,
        }))
    }


    const MAX_ROWS_ICD4 = 4;
    const [selectedIcdType, setSelectedIcdType] = useState("ICD_10");


    const handleIcdTypeChange = (oldGroup, rowIndex, newType) => {
        if (oldGroup === newType) return;

        setNewdata((prev) => {
            const oldGroupRows = [...(prev.icdCodes[oldGroup] || [])];

            // If the row doesn't exist, do nothing (prevents action on empty input row)
            if (!oldGroupRows[rowIndex]) {
                // Instead just change the selectedIcdType for UI
                setSelectedIcdType(newType);
                return prev;
            }

            const [movedRow] = oldGroupRows.splice(rowIndex, 1);

            const newGroupRows = [...(prev.icdCodes[newType] || [])];
            newGroupRows.push({
                ...movedRow,
                category: newType,
            });

            return {
                ...prev,
                icdCodes: {
                    ...prev.icdCodes,
                    [oldGroup]: oldGroupRows,
                    [newType]: newGroupRows,
                },
            };
        });
    };

    const [pendingIcdCode, setPendingIcdCode] = useState({ ICD_9: "", ICD_10: "" });


    const handleIcdCodeChange = (group, rowIndex, code) => {
        if (!code) return;

        const selectedIcd = icdCodes.find(
            (item) => item.code === code && item.category === group
        );

        setNewdata((prev) => {
            const groupRows = [...(prev.icdCodes[group] || [])];

            if (rowIndex < groupRows.length) {
                // Update existing row
                groupRows[rowIndex] = {
                    ...groupRows[rowIndex],
                    code,
                    description: selectedIcd?.description || "",
                    id: selectedIcd?.id || "",
                };
            }


            return {
                ...prev,
                icdCodes: {
                    ...prev.icdCodes,
                    [group]: groupRows,
                },
            };
        });
    };


    // Add new row to ICD_9 or ICD_10
    const addNewRowicd4 = (group) => {
        const code = pendingIcdCode[group];
        // if (!code) return;

        const selectedIcd = icdCodes.find(
            (item) => item.code === code && item.category === group
        );

        setNewdata((prev) => {
            const icd9Rows = prev.icdCodes?.ICD_9 || [];
            const icd10Rows = prev.icdCodes?.ICD_10 || [];

            const totalRows = icd9Rows.length + icd10Rows.length;

            if (totalRows >= MAX_ROWS_ICD4) {
                toast.warning(`Maximum ${MAX_ROWS_ICD4} total ICD rows allowed`);
                return prev;
            }

            const groupRows = prev.icdCodes[group] || [];

            return {
                ...prev,
                icdCodes: {
                    ...prev.icdCodes,
                    [group]: [
                        ...groupRows,
                        {
                            code,
                            description: selectedIcd?.description || "",
                            category: group,
                            id: selectedIcd?.id || "",
                        },
                    ],
                },
            };
        });

        // Clear pending selected code
        setPendingIcdCode((prev) => ({
            ...prev,
            [group]: "",
        }));
    };


    useEffect(() => {

    }, [newdata?.icdCodes])


    // const addNewRowicd4 = (group) => {
    //   setNewdata(prev => {
    //     const rows = prev.icdCodes[group] || [];
    //     if (rows.length >= MAX_ROWS_ICD4) {
    //       toast.warning(`Maximum ${MAX_ROWS_ICD4} ${group} rows allowed`);
    //       return prev;
    //     }
    //     return {
    //       ...prev,
    //       icdCodes: {
    //         ...prev.icdCodes,
    //         [group]: [...rows, { code: "", description: "", category: group }],
    //       },
    //     };
    //   });
    // };

    // Remove row (keep empty list allowed; UI fallback handles “no rows” state)
    const removeIcdRow = (group, index) => {
        setNewdata(prev => {
            const rows = [...(prev.icdCodes[group] || [])];
            rows.splice(index, 1);
            return { ...prev, icdCodes: { ...prev.icdCodes, [group]: rows } };
        });
    };



    useEffect(() => {
        const data = selectedItems;
        setNewdata((prev) => ({
            ...prev,
            cptCode: data,
        }));
    }, [selectedItems]);

    const handleCptChange = (index, value, type) => {
        setNewdata((prev) => {
            const updatedCptCode = [...prev.cptCode];

            if (type === "unit") {
                // Allow blank input (user is still typing)
                if (value === "") {
                    updatedCptCode[index] = {
                        ...updatedCptCode[index],
                        unit: "",
                    };
                } else {
                    const inputValue = Number(value);

                    // Prevent unit = 0
                    if (inputValue === 0) {
                        toast.error("Unit cannot be 0");
                        return prev; // don't update
                    }

                    updatedCptCode[index] = {
                        ...updatedCptCode[index],
                        unit: inputValue,
                    };
                }
            }

            return {
                ...prev,
                cptCode: updatedCptCode,
            };
        });
    };


    //  const handleCptChange = (index, value, type) => {
    //   setNewdata((prev) => {
    //     const updatedCptCode = [...prev.cptCode];

    //     if (type === "unit") {
    //       const inputValue = value === '' ? '' : Number(value);
    //       if (inputValue === 0) {
    //         toast.error("Unit cannot be 0");
    //         return prev;
    //       }
    //       updatedCptCode[index] = {
    //         ...updatedCptCode[index],
    //         unit: inputValue,
    //       };
    //     }

    //     return {
    //       ...prev,
    //       cptCode: updatedCptCode,
    //     };
    //   });
    // };
    let TotalAmount = newdata?.cptCode?.reduce((sum, item) => {
        const fee = parseFloat(item?.cptDetailsData?.fees1 || 0);
        const unit = parseFloat(item?.unit || 0);
        return sum + fee * unit;
    }, 0);


    useEffect(() => {
        setNewdata((prev) => ({
            ...prev,
            totalAmount: TotalAmount,
        }));
    }, [TotalAmount]);



    useEffect(() => {
        if (newdata?.caseType) {
            setResponsibleParty(newdata.caseType);
        }
    }, [newdata?.caseType]);


    useEffect(() => {
        if (newdata?.acceptAssignment) {
            setAcceptAssignment(newdata.acceptAssignment);
        }
    }, [newdata?.acceptAssignment]);

    // const handleIcdChangeByIndex = (e, icdIndex, rowIndex) => {
    //     const isChecked = e.target.checked;

    //     setNewdata((prevState) => {
    //         const updatedCptDetails = [...prevState.cptCode];

    //         const currentIcdList = updatedCptDetails[rowIndex].icd || [];

    //         updatedCptDetails[rowIndex].icd = isChecked
    //             ? [...currentIcdList, icdIndex]
    //             : currentIcdList.filter((idx) => idx !== icdIndex);


    //         return {
    //             ...prevState,
    //             cptCode: updatedCptDetails,
    //         };
    //     });
    // };

    const handleIcdChangeByIndex = (e, icdId, cptIndex) => {
        setNewdata(prev => {
            const updatedCptCode = [...prev.cptCode];
            const currentICDs = updatedCptCode[cptIndex].icd || [];

            let updatedICDs;
            if (e.target.checked) {
                updatedICDs = [...currentICDs, icdId]; // add
            } else {
                updatedICDs = currentICDs.filter(id => id !== icdId); // remove
            }

            updatedCptCode[cptIndex] = {
                ...updatedCptCode[cptIndex],
                icd: updatedICDs
            };

            return {
                ...prev,
                cptCode: updatedCptCode
            };
        });
    };

    const moveItemUp = (rowIndex, icdIndex) => {
        setNewdata(prev => {
            // Ensure prev.cptCode exists and is an array before proceeding
            const updatedCptDetails = Array.isArray(prev.cptCode) ? [...prev.cptCode] : [];
            const currentIcds = Array.isArray(updatedCptDetails[rowIndex]?.icd) ? [...updatedCptDetails[rowIndex].icd] : [];

            if (icdIndex > 0) {
                // Swap the ICD values if possible
                [currentIcds[icdIndex - 1], currentIcds[icdIndex]] = [currentIcds[icdIndex], currentIcds[icdIndex - 1]];
                updatedCptDetails[rowIndex].icd = currentIcds;
            }

            return {
                ...prev,
                cptCode: updatedCptDetails,
            };
        });
    };

    const moveItemDown = (rowIndex, icdIndex) => {
        setNewdata(prev => {
            // Ensure prev.cptCode exists and is an array before proceeding
            const updatedCptDetails = Array.isArray(prev.cptCode) ? [...prev.cptCode] : [];
            const currentIcds = Array.isArray(updatedCptDetails[rowIndex]?.icd) ? [...updatedCptDetails[rowIndex].icd] : [];

            if (icdIndex < currentIcds.length - 1) {
                // Swap the ICD values if possible
                [currentIcds[icdIndex], currentIcds[icdIndex + 1]] = [currentIcds[icdIndex + 1], currentIcds[icdIndex]];
                updatedCptDetails[rowIndex].icd = currentIcds;
            }

            return {
                ...prev,
                cptCode: updatedCptDetails,
            };
        });
    };


    return (
        <div>
            {spinner && <Spinner />}
            <ToastContainer limit={1} autoClose={1000} />
            <div className=''>
                <div className="m-3">
                    {/* Page Title */}
                    <div className="text-center section_header">Superbill</div>
                    {/* Patient Details */}
                    <div className="text-center section_header shadow-sm bgLightBlue1 font-14 fw-5 text-white p-2">
                        Patient Details
                    </div>
                    <div className="col-12 mt-4 border-bottom pb-3">
                        <div className="row g-3">
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={50}
                                    name="patientName"
                                    value={`${newdata?.patientFirstName || ""} ${newdata?.patientLastName || ""}`}
                                    data={{ label: "Patient Name", placeholder: "Enter full name", type: "text" }}
                                    readOnly
                                />
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={100}
                                    name="location"
                                    value={newdata?.clinicName || ""}
                                    data={{ label: "Location", placeholder: "", type: "text" }}
                                    readOnly
                                />
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={50}
                                    name="payerId"
                                    value={newdata?.payerId || ""}
                                    data={{ label: "Payer Id", placeholder: "", type: "text" }}
                                    readOnly
                                />
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={50}
                                    name="responsibleParty"
                                    value={newdata?.responsibleParty || ""}
                                    data={{ label: "Responsible Party Name", placeholder: "", type: "text" }}
                                    readOnly
                                />
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={50}
                                    name="insuranceName"
                                    value={newdata?.insuranceCompanyName || ""}
                                    data={{ label: "Insurance Name", placeholder: "", type: "text" }}
                                    readOnly
                                />
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={50}
                                    insurancePlan
                                    value={newdata?.insurancePlan || ""}
                                    data={{ label: "Plan Type", placeholder: "-", type: "text" }}
                                    readOnly
                                />
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap mt-3">Case Type</label>
                                <select className="form-select form-select-sm"
                                    name="caseType" value={newdata?.caseType || ""} onChange={handleChange}
                                    style={{
                                        borderColor: claimFormError.caseType ? 'red' : ""
                                    }}>
                                    <option value="">Select</option>
                                    <option value="INSURANCE">INSURANCE</option>
                                    <option value="SELF_PAY">SELF_PAY</option>

                                </select>
                                {claimFormError.caseType && (
                                    <div className="text-danger" style={{ fontSize: "13px" }}>
                                        {claimFormError.caseType}
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>

                    {/* Provider Details */}
                    <div className="text-center section_header shadow-sm bgLightBlue1 font-14 fw-5 text-white p-2 mt-3">
                        Provider Details
                    </div>
                    <div className="col-12 mt-4 border-bottom pb-3">
                        <div className="row g-3">
                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Provider Name</label>
                                <select className="form-select form-select-sm"
                                    name="providerId" value={newdata?.providerId} onChange={handleChange}
                                    style={{
                                        borderColor: claimFormError.providerId ? 'red' : ""
                                    }}>
                                    <option value="">Select</option>
                                    {providerList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                {claimFormError.providerId && (
                                    <div className="text-danger" style={{ fontSize: "13px" }}>
                                        {claimFormError.providerId}
                                    </div>
                                )}
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Billing Provider</label>
                                <select className="form-select form-select-sm"
                                    name="billingProviderId" value={newdata?.billingProviderId} onChange={handleChange}>
                                    <option value="">Select</option>
                                    {providerList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Rendering Provider</label>
                                <select className="form-select form-select-sm"
                                    name="renderingProviderId" value={newdata?.renderingProviderId} onChange={handleChange}>
                                    <option value="">Select</option>
                                    {providerList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Referring Provider</label>
                                <select className="form-select form-select-sm"
                                    name="referringProviderId" value={newdata?.referringProviderId} onChange={handleChange} >
                                    <option value="">Select</option>
                                    {providerList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Type Of Service</label>
                                <select className="form-select form-select-sm"
                                    name="typeOfService"
                                    onChange={handleChange}
                                    value={newdata?.typeOfService}
                                    style={{
                                        borderColor: claimFormError.typeOfService ? 'red' : ""
                                    }}>
                                    <option value="">Select</option>
                                    {type_of_service.map((data, index) => (
                                        <option key={index} value={data.key}>
                                            {data.name}
                                        </option>
                                    ))}
                                </select>
                                {claimFormError.typeOfService && (
                                    <div className="text-danger" style={{ fontSize: "13px" }}>
                                        {claimFormError.typeOfService}
                                    </div>
                                )}
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Place Of Service</label>
                                <select className="form-select form-select-sm"
                                    name="placeOfService" value={newdata?.placeOfService}
                                    onChange={handleChange}
                                    style={{
                                        borderColor: claimFormError.placeOfService ? 'red' : ""
                                    }}>
                                    <option value="">Select</option>
                                    {palceOfTreatmentlist.map((item) => (
                                        <option key={item.code} value={item.code}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                {claimFormError.placeOfService && (
                                    <div className="text-danger" style={{ fontSize: "13px" }}>
                                        {claimFormError.placeOfService}
                                    </div>
                                )}
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12 d-flex align-items-center">
                                <FormControl>
                                    <FormLabel
                                        id="isDental-label"
                                        className="font-11 fw-6 black"
                                    >
                                        Dental?
                                    </FormLabel>
                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="isDental-label"
                                        name="isDental"
                                        value={newdata?.isDental}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12 d-flex align-items-center">
                                <FormControl>
                                    <FormLabel
                                        id="isMedical-label"
                                        className="font-11 fw-6 black"
                                    >
                                        Medical?
                                    </FormLabel>
                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="isMedical-label"
                                        name="isMedical"
                                        value={newdata?.isMedical}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12 d-flex align-items-center">
                                <FormControl>
                                    <FormLabel
                                        id="encloser-label"
                                        className="font-11 fw-6 black"
                                    >
                                        Enclosures
                                    </FormLabel>
                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="encloser-label"
                                        name="encloser"
                                        value={newdata?.encloser}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12 d-flex align-items-center">
                                <FormControl>
                                    <FormLabel
                                        id="treatmentOfOrtho-label"
                                        className="font-11 fw-6 black"
                                    >
                                        Is Treatment For Orthodontics?
                                    </FormLabel>
                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="treatmentOfOrtho-label"
                                        name="treatmentOfOrtho"
                                        value={newdata?.treatmentOfOrtho}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12" >
                                <DateInput
                                    maxDate={new Date()}
                                    // error={claimFormError?.orthoDate}
                                    isRequired={newdata?.treatmentOfOrtho == "Yes"}
                                    size="small"
                                    variant="outlined"
                                    className="form-field-design w-100 fullWidth"
                                    Label={'Date Appliance Placed'}
                                    SelectedDate={newdata?.orthoDate ? new Date(newdata.orthoDate) : null}
                                    handleDateChange={(date) => handleInputChange({ target: { name: "orthoDate", value: date } })}
                                    disabled={newdata?.treatmentOfOrtho !== "Yes"}
                                />

                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={2}
                                    name={'monthOfTreatment'}
                                    value={newdata?.monthOfTreatment}
                                    // onBlur={(e) => handleBlur(e)}
                                    onChange={(e) => handleInputChange(e)}
                                    // error={claimFormError?.monthOfTreatment}
                                    required={newdata?.treatmentOfOrtho == "Yes"}
                                    disabled={newdata?.treatmentOfOrtho !== "Yes"}
                                    data={{ label: 'Month Of Treatment', placeholder: '', type: 'number' }} />
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12 d-flex align-items-center">
                                <FormControl>
                                    <FormLabel
                                        id="replacementOfProsthesis-label"
                                        className="font-11 fw-6 black"
                                    >
                                        Replacement of Prosthesis
                                    </FormLabel>
                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="replacementOfProsthesis-label"
                                        name="replacementOfProsthesis"
                                        value={newdata?.replacementOfProsthesis}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12" >
                                <DateInput
                                    maxDate={new Date()}
                                    // error={claimFormError?.placementDate}
                                    isRequired={newdata?.replacementOfProsthesis == "Yes"}
                                    size="small"
                                    variant="outlined"
                                    className=" form-field-design w-100 fullWidth"
                                    // isRequired={true}
                                    Label={'Date of Prior Placement'}
                                    SelectedDate={newdata?.placementDate ? new Date(newdata.placementDate) : null}
                                    handleDateChange={(date) => handleInputChange({ target: { name: "placementDate", value: date } })}
                                    disabled={newdata?.replacementOfProsthesis !== "Yes"}
                                />
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12 d-flex align-items-center">
                                <FormControl>
                                    <FormLabel
                                        id="treatmentOfOrtho-label"
                                    >
                                        <span className="font-11 fw-6 black"> Treatment Resulting Form</span>
                                        <span className='ms-2 cursor font-11 blue-color fw-6 ' onClick={() => setNewdata((prev) => ({ ...prev, treatmentResultingForm: null }))}>{"(Reset)"}</span>
                                    </FormLabel>
                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="treatmentResultingForm-label"
                                        name="treatmentResultingForm"
                                        value={newdata?.treatmentResultingForm}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="Occupational" control={<Radio />} label="Occupational illness/injury" />
                                        <FormControlLabel value="Auto" control={<Radio />} label="Auto accident" />
                                        <FormControlLabel value="Other" control={<Radio />} label="Other accident" />

                                    </RadioGroup>
                                </FormControl>
                                {/* <div className='red font-11'>{claimFormError?.treatmentResultingForm ? claimFormError?.treatmentResultingForm : ''}</div>  */}
                            </div>

                            <div className="col-lg-3 col-sm-6 col-12" >
                                <DateInput
                                    maxDate={new Date()}
                                    // error={claimFormError?.dateAutoAccident}
                                    isRequired={newdata?.treatmentResultingForm == "Auto"}
                                    size="small"
                                    variant="outlined"
                                    className=" form-field-design w-100 fullWidth"
                                    Label={'Date of Accident'}
                                    SelectedDate={newdata?.dateAutoAccident ? new Date(newdata.dateAutoAccident) : null}
                                    handleDateChange={(date) => handleInputChange({ target: { name: "dateAutoAccident", value: date } })}
                                    disabled={newdata?.treatmentResultingForm !== "Auto"}
                                />
                            </div>
                            <div className="col-lg-3 col-sm-6 col-12">
                                <FormField
                                    maxLength={10}
                                    name={'autoAccidentState'}
                                    value={newdata?.autoAccidentState}
                                    // onBlur={(e) => handleBlur(e)}
                                    onChange={(e) => handleInputChange(e)}
                                    error={claimFormError?.autoAccidentState}
                                    required={newdata?.treatmentResultingForm == "Auto"}
                                    disabled={newdata?.treatmentResultingForm !== "Auto"}
                                    data={{ label: 'Auto Accident state', placeholder: '', type: 'text' }} />
                            </div>

                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
                                <label className='font-11 fw-6' htmlFor="">Remarks</label>
                                <textarea className='form-control' value={newdata?.remarks} name="remarks" onChange={(e) => { handleInputChange(e); }}></textarea>
                                {/* <div className='red font-11'>{diagnosisError?.Remarks ? diagnosisError?.Remarks : ''}</div> */}
                            </div>

                        </div>
                    </div>

                    {/* Insurance Portion Details */}
                    <div className="text-center section_header shadow-sm bgLightBlue1 font-14 fw-5 text-white p-2 mt-3">
                        Insurance Portion Details
                    </div>
                    <div className="col-12 mt-4 border-bottom pb-3">
                        <div className="row g-3 align-items-end">
                            {/* <div className="col-lg-4 col-sm-6 col-12">
                    <label className="fw-6 font-11 text-nowrap">Plan</label>
                    <select className="form-select form-select-sm">
                      <option>Select Plan</option>
                    </select>
                  </div> */}

                            <div className="col-lg-4 col-sm-6 col-12">
                                <label className="fw-6 font-11 text-nowrap">Insurance Order</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="coverage"
                                    value={newdata.coverage || ""}
                                    onChange={handleChange}
                                >
                                    <option value="" hidden>Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                            </div>


                            <div className="col-lg-4 col-12">
                                <FormControl>
                                    <FormLabel id="treatmentOfOrtho-label" className="font-11 fw-6 black">
                                        Bill Insurance
                                    </FormLabel>

                                    <RadioGroup
                                        className="flex-wrap"
                                        row
                                        aria-labelledby="treatmentOfOrtho-label"
                                        value={responsibleParty === 'INSURANCE' ? 'Yes' : 'No'}  // Set value based on condition
                                        readOnly
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>

                            </div>
                        </div>
                    </div>

                    {/* ICD Details */}
                    <div className="text-center section_header shadow-sm bgLightBlue1 font-14 fw-5 text-white p-2 mt-3">
                        ICD Details
                    </div>
                    <div className="col-8 mt-4 pb-3">
                        <div className="table-responsive">
                            <table className="table table-sm align-middle">
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Code</th>
                                        <th>Description</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* when no rows for the selected type -> show Add button row */}
                                    {['ICD_9', 'ICD_10'].map((group) => {
                                        const rows = newdata?.icdCodes?.[group] || [];

                                        return (
                                            <React.Fragment key={group}>
                                                {/* Existing rows */}
                                                {rows.map((row, i) => (
                                                    <tr key={`${group}-${i}`}>
                                                        {/* Type dropdown */}
                                                        <td>
                                                            <select
                                                                className="form-select form-select-sm"
                                                                value={row.category}
                                                                onChange={(e) => handleIcdTypeChange(group, i, e.target.value)}
                                                            >
                                                                {/* <option value="ICD_9">ICD 9</option> */}
                                                                <option value="ICD_10">ICD 10</option>
                                                            </select>
                                                        </td>

                                                        {/* Code dropdown */}
                                                        <td>
                                                            <select
                                                                className="form-select form-select-sm"
                                                                value={row.code}
                                                                onChange={(e) => handleIcdCodeChange(row.category, i, e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {icdCodes
                                                                    .filter((item) => item.category === row.category)
                                                                    .map((item) => (
                                                                        <option key={item.code} value={item.code}>
                                                                            {item.code}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </td>

                                                        {/* Description */}
                                                        <td>
                                                            <input
                                                                className="form-control form-control-sm"
                                                                value={row.description}
                                                                readOnly
                                                            />
                                                        </td>

                                                        {/* Add / Remove */}
                                                        <td className="text-nowrap">
                                                            <IoAddCircle
                                                                size={22}
                                                                className={`cursor-pointer ${!canAddMore ? "text-primary" : "text-muted"}`}
                                                                onClick={() => {
                                                                    if (!canAddMore) {
                                                                        addNewRowicd4(group);
                                                                    }
                                                                }}
                                                                title="Add row"
                                                            />

                                                            {
                                                                i > 0 && (
                                                                    <IoRemoveCircle
                                                                        size={22}
                                                                        className="ms-2 red-color cursor"
                                                                        onClick={() => removeIcdRow(row.category, i)}
                                                                        title="Remove row"
                                                                    />
                                                                )
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}


                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {/* CDT Details */}
                    <div className="text-center section_header shadow-sm bgLightBlue1 font-14 fw-5 text-white p-2 mt-3">
                        CDT Details
                    </div>
                    <div className="col-12 mt-4 border-bottom pb-3">
                        <div className="table-responsive">
                            <table className="table table-sm align-middle">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Procedure Date</th>
                                        <th>Area of Oral Cavity</th>
                                        {/* <th>Tooth System</th> */}
                                        <th>Tooth Number or Letter</th>
                                        <th>Tooth Surface</th>
                                        <th>Procedure Code</th>
                                        <th>Description</th>
                                        <th>Unit</th>
                                        <th className="text-center">Fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newdata?.cptCode?.map((item, i) => (
                                        <tr key={i}>
                                            <td>{i}</td>
                                            <td><input type="date" className="form-control form-control-sm" value={moment(item?.procedureDate).format("YYYY-MM-DD")} /></td>
                                            <td><input className="form-control form-control-sm" value={item?.toothSurface} readOnly /></td>
                                            {/* <td><input className="form-control form-control-sm" placeholder="JP" /></td> */}
                                            <td><input className="form-control form-control-sm" value={item?.toothNumber} readOnly /></td>
                                            <td><input className="form-control form-control-sm" value={item?.toothSurface} readOnly /></td>
                                            <td><input className="form-control form-control-sm" value={item?.cptDetailsData?.code} readOnly /></td>
                                            <td><input className="form-control form-control-sm" value={item?.cptDetailsData?.description} readOnly /></td>
                                            <td>
                                                <input className="form-control form-control-sm text-end"
                                                    value={item.unit ?? ""}
                                                    onChange={(e) => handleCptChange(i, e.target.value, 'unit')} />
                                            </td>
                                            <td><input className="form-control form-control-sm text-end" type='number' value={item?.cptDetailsData?.fees1 || ""} readOnly /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>




                    {/* Totals & Flags */}
                    <div className="row g-3 mt-3">
                        <div className="col-md-4">
                            <FormField name="totalAmount" data={{ label: "Total Amount", placeholder: "", type: "text" }} value={newdata?.totalAmount} readOnly />
                        </div>
                        <div className="col-md-8">
                            <div className="row g-3">
                                <div className="col-sm-4">
                                    <FormControl>
                                        <FormLabel id="showReferringProvider-label" className="font-11 fw-6 black">
                                            Show Referring Provider
                                        </FormLabel>

                                        <RadioGroup
                                            className="flex-wrap"
                                            row
                                            aria-labelledby="showReferringProvider-label"
                                            name="showReferringProvider"
                                            value={newdata.showReferringProvider}
                                            onChange={(e) =>
                                                setNewdata((prev) => ({ ...prev, showReferringProvider: e.target.value === 'true' }))
                                            }
                                        >
                                            <FormControlLabel
                                                value="true"
                                                control={<Radio />}
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="false"
                                                control={<Radio />}
                                                label="No"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                <div className="col-sm-4">
                                    <FormControl>
                                        <FormLabel id="acceptAssignment-label" className="font-11 fw-6 black">
                                            Accept Assignment
                                        </FormLabel>

                                        <RadioGroup
                                            className="flex-wrap"
                                            row
                                            aria-labelledby="acceptAssignment-label"
                                            name="acceptAssignment"
                                            value={acceptAssignment}
                                            onChange={(e) => setAcceptAssignment(e.target.value)}
                                        >
                                            <FormControlLabel value="A" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="C" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-4 border-bottom pb-3">
                        <div className="table-responsive">
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Procedure code</th>
                                        <th>ICD(s)</th>
                                        <th>Linked--ICD(s)</th>
                                        <th>Units</th>
                                        <th>Fee</th>
                                        <th className='text-center'>Order</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newdata?.cptCode?.map((data, index) => (
                                        <tr key={index}>
                                            {/* ADA Code */}
                                            <td>{data?.cptDetailsData?.code}</td>
                                            {/* ICD Checkboxes */}
                                            <td>
                                                <FormGroup>
                                                    {newdata?.icdCodes?.ICD_10?.slice(0, MAX_ROWS_ICD4)?.map((item, icdIndex) => (
                                                        <div className="d-flex align-items-center" key={item.id}>
                                                            {item.code && (
                                                                <>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={data.icd?.includes(icdIndex.toString())}
                                                                                onChange={(e) => handleIcdChangeByIndex(e, icdIndex.toString(), index)}
                                                                            />
                                                                        }
                                                                    />
                                                                    <label>{item.code} - {item.description}</label>
                                                                </>
                                                            )}
                                                        </div>
                                                    ))}
                                                </FormGroup>

                                                {/* <FormGroup>
                                                    {newdata?.icdCodes?.ICD_10?.slice(0, MAX_ROWS_ICD4)?.map((item) => (
                                                        <div className="d-flex align-items-center" key={item.id}>
                                                            {
                                                                item.code ?
                                                                    <>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <input
                                                                                    checked={item.id}
                                                                                    onChange={(e) => handleIcdChangeByIndex(e, item.id, index)}
                                                                                    type='checkBox' />
                                                                            }
                                                                        />
                                                                        <label>{item.code} - {item.description}</label>
                                                                    </>
                                                                    : ""
                                                            }
                                                        </div>
                                                    ))}
                                                </FormGroup> */}

                                            </td>

                                            {/* Linked ICDs */}
                                            <td style={{ verticalAlign: 'top' }}>
                                                {(data.icd || []).map((icdIndex) => {
                                                    const icdItem = newdata?.icdCodes?.ICD_10?.[icdIndex];
                                                    return (
                                                        <div>
                                                            {icdItem?.code || '-'} -  {icdItem?.description || '-'}
                                                        </div>
                                                    );
                                                })}
                                            </td>


                                            {/* Unit + Fee */}
                                            < td > {data?.unit || '-'}</td>
                                            <td>{data?.fee1 || '-'}</td>

                                            {/* Order Control */}
                                            <td className="text-center" style={{ verticalAlign: 'top' }}>
                                                {data?.icd?.map((icd, icdIndex) => (
                                                    <div key={icdIndex} className='d-flex align-items-center justify-content-center'>
                                                        <div onClick={() => moveItemUp(index, icdIndex)}>
                                                            <KeyboardArrowUp style={{ fontSize: "30px" }} />
                                                        </div>
                                                        {icd}
                                                        <div onClick={() => moveItemDown(index, icdIndex)}>
                                                            <KeyboardArrowDown style={{ fontSize: "30px" }} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='d-flex justify-content-end mt-3'>
                        <NavLink to="/superbill-list" className='btn btn-secondary'>Cancel</NavLink>
                        <button className='btn btn-primary ms-2' onClick={handleUpdateBill}>Update</button>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default UpdateSuperBill